<template>
  <div>

    <el-card class="box-card" style="margin-top: 10px">
      <div slot="header" class="clearfix">
        <span>推荐配置</span>
      </div>
      <el-form>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="数量">
              <el-input v-model.number="recommend.top_num" placeholder="数量" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12" />
          <el-form-item label="人数范围" />
          <el-form :inline="true">
            <el-row v-for="(item, index) in recommend.intervals" :key="index">
              <el-form-item label="开始">
                <el-input v-model.number="item.start" placeholder="开始" />
              </el-form-item>
              <el-form-item label="结束">
                <el-input v-model.number="item.end" placeholder="结束" />
              </el-form-item>
              <el-form-item label="数量">
                <el-input v-model.number="item.num" placeholder="数量" />
              </el-form-item>
              <el-form-item>
                <el-button type="danger" @click="del(index)">删除</el-button>
              </el-form-item>
            </el-row>
            <el-button type="primary" @click="add">+</el-button>
          </el-form>
        </el-row>
        <el-button style="margin-top: 10px;" type="primary" @click="onSubmit()">保存</el-button>
      </el-form>
    </el-card>

  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'Recommend',
  data() {
    return {
      key: 'CLUB_CONFIG:RECOMMEND:LIST',
      recommend: { 'top_num': 50, 'intervals': [{ 'start': 0, 'end': 3000, 'num': 10 }] }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    add() {
      this.recommend.intervals.push({ start: 0, end: 0, num: 0 })
    },
    del(index) {
      this.recommend.intervals = this.recommend.intervals.filter((item, idx) => {
        return idx !== index
      })
    },
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.recommend = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.recommend)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
